import data from "../../../../../src/Tooltip.docs.json";
import * as React from 'react';
export default {
  data,
  React
};